import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthService } from "./auth.service";

import { LoginComponent } from "../pages/login/login.component";
import { ProfileComponent } from "../pages/profile/profile.component";

import { AuthGuard } from "./auth.guard";

export const appRoutes: Routes = [
	{
		path: "",
		component: LoginComponent
	},
	{
		path: "profile",
		component: ProfileComponent,
		canActivate: [AuthGuard]
	},
	{
		path: "**",
		component: LoginComponent
	}
];

@NgModule({
	imports: [RouterModule.forRoot(appRoutes)],
	exports: [RouterModule],
	providers: [AuthService, AuthGuard]
})
export class CoreModule {}



// WEBPACK FOOTER //
// F:/Projects/anoki/src/app/core/core.module.ts